import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";

import { makeStyles } from "@mui/styles";
import avatar from "../../images/avatar.png";

import TextareaAutosize from "@mui/material/TextareaAutosize";

import {
  createFeedback,
  updateFeedback,
} from "../../helper/reveiwApiCalls/reveiw";
import { getUser } from "../../helper/authApiCalls/auth";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  borderRadius: "10px",
  transform: "translate(-50%, -50%)",
  width: 380,
  height: 500,
  bgcolor: "background.paper",
  boxShadow: 34,
  p: 4,
};

const useStyles = makeStyles({
  top: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "& > *": {
      margin: "0 10px",
    },
    margin: "10px 0 20px 0px",
  },
  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
  },
  flex: {
    display: "flex",
    alignItems: "center",
    padding: "0 10px",
    "& > *": {
      margin: "0 10px",
      width: "30px",
      cursor: "pointer",
      fontSize: "40px",
      border: "none",
      background: "transparent",
    },
  },

  textarea: {
    border: "1px solid black",
    fontSize: "17px",
    margin: "20px 0",
    padding: "20px",
    resize: "none",
  },
  button: {
    float: "right",
    margin: "30px",
    padding: "13px 20px",
    background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
    color: "white",
    cursor: "pointer",
    fontSize: "16px",
    border: "none",
    borderRadius: "12px",
  },
  cancel: {
    float: "right",
    margin: "30px",
    fontSize: "16px",
    border: "none",
    padding: "10px 20px",
    // eslint-disable-next-line no-dupe-keys
    border: "3px solid #4a1d85",

    borderImageSlice: 20,
    cursor: "pointer",
    borderRadius: "12px",
  },
  on: {
    color: "yellow",
  },
  off: {
    color: "#ccc",
  },
});

function PostReview({ open, setOpen, id, check }) {
  const handleClose = () => setOpen(false);
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const classes = useStyles();
  const [error, setError] = useState("");

  const [user, setUser] = useState({});
  const playlistId = id;
  const userId = user._id;
  useEffect(() => {
    getUser().then((data) => {
      setUser(data.data);
    });
  }, []);

  function ToEdit() {
    let info1 = {
      playlistId,
      feedbackId: check._id,
      comment: feedback,
      rating,
    };

    updateFeedback(info1).then((data) => {
      if (data.error) {
        setError(data.error);
      } else {
        window.location.reload(false);
      }
    });
  }

  function onSubmit() {
    let info2 = {
      userId,
      playlistId,
      feedback,
      rating,
    };

    if (rating === "" || feedback === "" || user.isVerified === false) {
      if (user.isVerified === false) {
        setError("Your account is not verified");
      } else {
        setError("please provide all fields");
      }
    } else {
      createFeedback(info2).then((data) => {
        if (data.error) {
          setError(data.error);
        } else {
          window.location.reload(false);
        }
      });
    }
  }

  const Name = user ? user.name : "user";

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box className={classes.top}>
              {user.profileimage === undefined && (
                <img src={avatar} alt="" className={classes.avatar} />
              )}
              {user.profileimage !== undefined && (
                <img
                  src={user.profileimage}
                  alt=""
                  className={classes.avatar}
                />
              )}
              <span>{Name}</span>
            </Box>
            <Box className={classes.flex}>
              {[...Array(5)].map((star, index) => {
                index += 1;
                return (
                  <button
                    type="button"
                    key={index}
                    className={
                      index <= (hover || rating) ? classes.on : classes.off
                    }
                    onClick={() => setRating(index)}
                    onMouseEnter={() => setHover(index)}
                    onMouseLeave={() => setHover(rating)}
                  >
                    <span className="star">&#9733;</span>
                  </button>
                );
              })}
            </Box>
            <TextareaAutosize
              aria-label="empty textarea"
              placeholder={
                check === undefined
                  ? "Write A review"
                  : "Edit Your Existing Review"
              }
              style={{ outline: "none", height: "200px", width: "100%" }}
              className={classes.textarea}
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />
            {error && <div className={classes.error}>*{error}</div>}
            {check === undefined && (
              <button className={classes.button} onClick={onSubmit}>
                Post
              </button>
            )}
            {check !== undefined && (
              <button className={classes.button} onClick={ToEdit}>
                Edit
              </button>
            )}

            <button className={classes.cancel} onClick={() => setOpen(false)}>
              Cancel
            </button>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default PostReview;
